
/*
	Config Module for OpeReady-Client 
*/
export default {
	THEME: {
		main: '#3C4F76',
		light: '#87BCDE',
		dark: '#383F51',
		error: '#A4333E',
		sucess: '#5C972F',
		text: '#2D2D2D',
		white: '#EDEDED'
	}
}

